import {
  COUNTRY_NAME,
  DEFAULT_LABEL,
  IEC_LABEL,
  REGEX,
  IEC_DETAILS,
  functionList,
  functionListSwedenNorwayIEC,
  PA_SCREENING_COUNTRIES,
  PERSONAL_ID_HELPER_TEXT_MAP,
} from "./constants";

export const getDisclaimerMap = (t) => ({
  [t("access.AUSTRALIA")]: {
    doc: t("newuser.AUDocNoteDisclaimer"),
    regulatory: t("newuser.AURegulatoryDisclaimer"),
  },
  [t("access.NEWZEALAND")]: {
    doc: t("newuser.NZDocNoteDisclaimer"),
    regulatory: t("newuser.NZRegulatoryDisclaimer"),
  },
});

export const getCountryZone = (country, listOfCountries) =>
  listOfCountries.includes(country);

export const replaceEmptySpace = (str) => str?.replace(REGEX.WHITESPACE, "");

export const getTransArr = (arr, t) =>
  arr.map((c) => t(`access.${replaceEmptySpace(c)}`));

export const getPAScreeningCountries = (t) => {
  return getTransArr(PA_SCREENING_COUNTRIES, t);
};

export const getCountryLabel = (country, t) => {
  const iecTranslated =
    t(`access.${replaceEmptySpace(COUNTRY_NAME.INTERNATIONALEUROCARD)}`) ||
    COUNTRY_NAME.INTERNATIONALEUROCARD;
  return country === iecTranslated ? IEC_LABEL : DEFAULT_LABEL;
};

export const getInfoFields = (country, field, t) => {
  const infoFields = {
    companyInfo: {
      INTERNATIONALEUROCARD: {
        bussRegName: t("newuser.businessRegisteredName"),
        bussRegAddress: t("newuser.businessRegisteredAddress"),
        bussRegPostcode: t("newuser.businessRegisteredPostalCode"),
        bussRegCountry: t("newuser.businessRegisteredCountry"),
      },
      DEFAULT: {
        bussRegName: t("newuser.companyRegisteredName"),
        bussRegAddress: t("newuser.companyRegisteredAddress"),
        bussRegPostcode: t("newuser.companyRegisteredPostalCode"),
        bussRegCountry: t("newuser.companyRegisteredCountry"),
      },
    },
    correspondenceInfo: {
      INTERNATIONALEUROCARD: {
        employerCompanyName: t("newuser.employerBusinessName"),
      },
      DEFAULT: {
        employerCompanyName: t("newuser.employerCompanyName"),
      },
    },
  };

  const countryLabel = getCountryLabel(country, t);
  return infoFields[field][countryLabel];
};

export const getNormalizedCountry = (country) =>
  (country || "").toString().toLowerCase().replace(REGEX.WHITESPACE, "");

export const GET_FUNCTION_LIST = (t, marketName) => {
  const props = {
    message: "",
    roles: [],
    fundingBillingAccount: "",
    maxLimitPerToken: "",
    dailyNumberOfTokens: "",
    maxSpendPerDay: "",
    thresholdAmount: "",
    notificationRecipient: "",
  };
  let list = [];
  switch (marketName) {
    case COUNTRY_NAME.SWEDEN:
    case COUNTRY_NAME.NORWAY:
      list = functionListSwedenNorwayIEC;
      break;
    case COUNTRY_NAME.INTERNATIONALEUROCARD:
      list = IEC_DETAILS;
      break;
    default:
      list = functionList;
  }
  return list?.map((market) => ({
    functionName: t(market.function),
    docName: market.docName,
    ...props,
  }));
};

export const isLanguageEnglish = (language) => {
  return language === "en";
};

export const getUserAccess = (t, accessState, user) => {
  const UK = t("access.UNITEDKINGDOM");
  let { functName = "", functRole = "", userCountry = "" } = accessState || {};

  const accesses = Array.isArray(user?.access) ? user.access : [];
  let ukCount = 0;
  let otherCount = 0;

  accesses.forEach((acc) => {
    if (acc.country === UK) ukCount++;
    else otherCount++;

    (acc.functions || []).forEach((funct) => {
      userCountry = acc.country;
      functName = funct.functionName;
      if (functName === t("products.functname2")) {
        (funct.roles || []).forEach((rol) => {
          functRole = rol.roleName;
        });
      }
    });
  });

  const isAPACAndUKAccess = ukCount > 0 && otherCount > 0;
  const onlyUKAccess = ukCount > 1 && otherCount === 0;

  return { functName, functRole, userCountry, onlyUKAccess, isAPACAndUKAccess };
};

export const isSwedenNorway = (country, t) => {
  const swedenLocale = t("access.SWEDEN");
  const norwayLocale = t("access.NORWAY");
  const swedenNorwayLocales = new Set([swedenLocale, norwayLocale]);
  return swedenNorwayLocales.has(country);
};

export const getUploaderLabel = (country, t, isModifyUser) => {

    const isSwedenNorwaySelected = isSwedenNorway(country, t);
    const isSingapore = country === t("access.SINGAPORE");

    if (isSwedenNorwaySelected) {
      return t("swedenNorway.supportingDocumentLabel");
    }
    if (isSingapore) {
      return t("singapore.supportingDocumentLabel");
    }
    if (isModifyUser) {
      return t("document.upload.supportingDocument");
    }
    return t("document.upload.supportingDocumentLabel");
  };

export const getPersonalIdHelperTextKey = (country, t) => {
  return PERSONAL_ID_HELPER_TEXT_MAP(t)[country] || null;
};

